/**
 * Monetization platform gate: native SDKs (ads/IAP) exist only in the Tauri
 * Android build. On web and desktop everything is a no-op.
 *
 * Detection without extra native plugins: inside Tauri the global
 * `__TAURI_INTERNALS__` exists, and the Android WebView gives itself away in the UA.
 */

export function isTauriRuntime(): boolean {
  return "__TAURI_INTERNALS__" in globalThis;
}

export function isAndroid(): boolean {
  return isTauriRuntime() && /android/i.test(globalThis.navigator?.userAgent ?? "");
}
